export enum ENROLMENT_STATUS {
    ENROLLED = 'ENROLLED',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED'
}
